import { useTranslation } from 'react-i18next';

import { fmtInt } from 'src/sections/@dashboard/home/metricas/MetricasUI';
import { MKT_CTWA_DESIGN as d } from 'src/pages/dashboard/Marketing/MarketingCtwa.design';
import { nomeAnuncio, plataformaAnuncio, PLATAFORMA_COR, rotuloMidia, truncarTexto, formatarUltimoContatoCapturado } from './ctwa.utils';
import CtwaAnuncioThumb from './CtwaAnuncioThumb';

export default function CtwaAnuncioList({ anuncios, maxTotal, onItemClick }) {
    const { t } = useTranslation('marketing');

    return (
        <div className={d.listWrap}>
            <div className={`${d.listRow} ${d.listHead}`}>
                <span className={d.listRank}>#</span>
                <span className={d.listThumb} aria-hidden />
                <span className={`${d.listAdCol} ${d.listHeadCell}`}>{t('ctwaPage.table.ad')}</span>
                <span className={`${d.listColPlat} ${d.listHeadCell}`}>{t('ctwaPage.filters.platform')}</span>
                <span className={`${d.listColNum} ${d.listHeadCell} text-right`}>{t('ctwaPage.table.entries')}</span>
                <span className={`${d.listColNum} ${d.listHeadCell} text-right`}>{t('ctwaPage.table.contacts')}</span>
                <span className={`${d.listColDate} ${d.listHeadCell} text-right`}>{t('ctwaPage.table.last')}</span>
                <span className={d.listColAction} aria-hidden />
            </div>

            {anuncios.map((anuncio, index) => {
                const titulo = nomeAnuncio(anuncio);
                const plataforma = plataformaAnuncio(anuncio.source_url);
                const pct = maxTotal > 0 ? Math.round((anuncio.total / maxTotal) * 100) : 0;

                return (
                    <div
                        key={anuncio.source_id}
                        className={`${d.listRow} ${onItemClick ? 'cursor-pointer' : ''}`}
                        onClick={() => onItemClick?.(anuncio)}
                        onKeyDown={onItemClick ? (e) => e.key === 'Enter' && onItemClick(anuncio) : undefined}
                        role={onItemClick ? 'button' : undefined}
                        tabIndex={onItemClick ? 0 : undefined}
                    >
                        <span className={d.listRank}>{index + 1}</span>
                        <div className={d.listThumb}>
                            <CtwaAnuncioThumb anuncio={anuncio} titulo={titulo} size="sm" />
                        </div>
                        <div className={d.listAdCol}>
                            <p className={d.listTitle}>{titulo}</p>
                            <p className={d.listSub}>
                                {truncarTexto(anuncio.body, 72)}
                                {anuncio.media_type ? ` · ${rotuloMidia(anuncio.media_type, t)}` : ''}
                            </p>
                            <div className={d.listBarTrack}>
                                <div className={d.listBarFill} style={{ width: `${pct}%` }} />
                            </div>
                        </div>
                        <span className={d.listColPlat} style={{ color: PLATAFORMA_COR[plataforma.id] }}>
                            {plataforma.label}
                        </span>
                        <span className={`${d.listColNum} font-bold tabular-nums`}>{fmtInt(anuncio.total)}</span>
                        <span className={`${d.listColNum} tabular-nums text-[#6b6b7b]`}>{fmtInt(anuncio.contatosUnicos)}</span>
                        <span className={`${d.listColDate} tabular-nums`} title={formatarUltimoContatoCapturado(anuncio.ultimaEntrada) || undefined}>
                            {formatarUltimoContatoCapturado(anuncio.ultimaEntrada) || '—'}
                        </span>
                        {anuncio.source_url ? (
                            <a
                                href={anuncio.source_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${d.adLink} ${d.listColAction}`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                ↗
                            </a>
                        ) : (
                            <span className={d.listColAction} />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
